import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import Highlighter from 'react-highlight-words'
import ReactResizeDetector from 'react-resize-detector'
import { buildSearchHighlightPatterns } from 'shared/utils/stringUtils'

export const SEARCH_MATCH_TEXT_COLOR = '#1A7FA0'
export const SEARCH_MATCH_HIGHLIGHT_BACKGROUND = '#FFF9C4'

const useStyles = makeStyles({
    contentDiv: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    searchTitleText: {
        fontSize: pxToRem(12),
        lineHeight: 1.4,
    },
})

interface SingleLineEllipsisForSearchProps {
    /**
     * Callback for when the truncation state changes.
     */
    onTruncate?: () => void

    /**
     * Text content.
     */
    text: string

    /**
     * Searched text in search bar
     */
    searchText?: string
    /**
     * Default width of highlighted text
     */
    defaultWidth?: string | number
}

/**
 *
 * This component truncates long texts, and shows
 * the full text in a tooltip.
 */
const SingleLineEllipsisForSearch = ({
    onTruncate,
    text = '',
    searchText = '',
    defaultWidth = 200,
}: SingleLineEllipsisForSearchProps) => {
    const classes = useStyles()
    const [divRef, setDivRef] = React.useState<HTMLDivElement | undefined>()
    const [isTruncated, setIsTruncated] = React.useState(false)

    const setRef = (element: HTMLDivElement) => {
        setDivRef(element)
    }

    const handleResize = (width: number) => {
        if (divRef) {
            setIsTruncated(divRef?.scrollWidth > Math.round(width))
            onTruncate?.()
        }
    }

    return (
        <div className={classes.contentDiv}>
            <HoverTooltip text={isTruncated ? text : ''}>
                <div ref={setRef} className={classes.contentDiv}>
                    <span>
                        <Highlighter
                            className={classes.searchTitleText}
                            style={{
                                width: defaultWidth,
                            }}
                            autoEscape={false}
                            searchWords={buildSearchHighlightPatterns(searchText)}
                            textToHighlight={text}
                            highlightStyle={{
                                backgroundColor: SEARCH_MATCH_HIGHLIGHT_BACKGROUND,
                                fontWeight: 500,
                                color: SEARCH_MATCH_TEXT_COLOR,
                                padding: 0,
                            }}
                        />
                    </span>
                </div>
            </HoverTooltip>
            {divRef && (
                <ReactResizeDetector
                    handleWidth
                    onResize={handleResize}
                    targetDomEl={divRef}
                />
            )}
        </div>
    )
}

export default SingleLineEllipsisForSearch
